import React from 'react'
import { DolaThemes } from '../../styles/types'
import ProgressItem, { ProgressItemProps } from './ProgressItem'
import Stick from './Stick'
import { Progress } from './styles'

interface NumberedProgressProps {
  items: Pick<ProgressItemProps, 'active' | 'n' | 'onClick'>[]
  isComplete: boolean
  theme?: DolaThemes
}

const NumberedProgress: React.FC<NumberedProgressProps> = ({
  items,
  isComplete,
  theme = 'light',
}) => {
  return (
    <Progress>
      {items.map((item) => {
        return (
          <ProgressItem
            count={items.length}
            theme={theme}
            key={item.n}
            {...item}
          />
        )
      })}
      <Stick theme={theme} active={isComplete} />
    </Progress>
  )
}

export default NumberedProgress
